var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentSuccessful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5",
    "data-name": "Group 5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 744.019,
    height: 209.828,
    viewBox: "0 0 744.019 209.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 744.019,
    height: 209.828,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 9.333,
    height: 17.419,
    transform: "translate(39.976 77.181) rotate(-53.664)",
    fill: "#0071bc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M77.81,32.391a1.9,1.9,0,0,0-2.4-.378l-.475-.91a2.762,2.762,0,0,1,3.414.862l-.537.426",
    transform: "translate(-2.743 -1.129)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M42.529,88.72a4.368,4.368,0,0,0,5.538.665l1.164,2.046a6.332,6.332,0,0,1-7.9-1.693c.4-.339.8-.677,1.195-1.018",
    transform: "translate(-1.513 -3.248)",
    fill: "#009245"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M24.193,31.13a1.2,1.2,0,0,0,1.448-.517l.539.361a1.746,1.746,0,0,1-2.156.554c.056-.133.113-.265.17-.4",
    transform: "translate(-0.879 -1.121)",
    fill: "#c1272d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 4.449,
    height: 8.908,
    transform: "matrix(0.295, -0.956, 0.956, 0.295, 89.281, 28.346)",
    fill: "#009245"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 3.566,
    height: 7.141,
    transform: "matrix(0.973, -0.229, 0.229, 0.973, 49.079, 37.079)",
    fill: "#fcee21"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 7.058,
    height: 3.524,
    transform: "translate(0 67.25) rotate(-47.279)",
    fill: "#662d91"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 2.172,
    height: 6.521,
    transform: "translate(101.947 57.587) rotate(-33.27)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 1.162,
    height: 1.345,
    transform: "translate(52.845 98.442) rotate(-73.654)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M140.964,78.772c-.23-3.676,2.054-6.34,4.37-6.894a3.706,3.706,0,0,0,.182,2.083c-1.682.822-3.066,3.579-1.688,6.668a7.958,7.958,0,0,1-2.864-1.856",
    transform: "translate(-5.16 -2.631)",
    fill: "#662d91"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 4.092,
    height: 7.541,
    transform: "matrix(0.899, -0.437, 0.437, 0.899, 37.171, 51.07)",
    fill: "#ed1e79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M250.033,23.327a7.647,7.647,0,0,0,1.623,9.625q-1.429,1.486-2.859,2.968a11.085,11.085,0,0,1-1.065-14.1q1.152.751,2.3,1.5",
    transform: "translate(-8.994 -0.799)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M170.076,106.229a1.143,1.143,0,0,0-1.4.424l-.494-.367a1.655,1.655,0,0,1,2.068-.427l-.178.37",
    transform: "translate(-6.157 -3.868)",
    fill: "#009245"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M202.545.206A4.187,4.187,0,0,0,205.6,4.6q-.361,1.069-.724,2.138A6.068,6.068,0,0,1,201.054,0c.5.068.993.139,1.49.206",
    transform: "translate(-7.356)",
    fill: "#c1272d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 7.415,
    height: 3.703,
    transform: "matrix(0.947, -0.321, 0.321, 0.947, 162.634, 65.012)",
    fill: "#fcee21"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 5.001,
    height: 10.017,
    transform: "translate(132 93.6) rotate(-67.166)",
    fill: "#662d91"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 0.928,
    height: 2.788,
    transform: "translate(190.524 92.602) rotate(-86.613)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 3.458,
    height: 4,
    transform: "matrix(0.6, -0.8, 0.8, 0.6, 175.901, 107.998)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M272.584,81.886a1.857,1.857,0,0,1-2.033,1.17,1.079,1.079,0,0,0,.232-.554,1.452,1.452,0,0,0,1.32-1.471,2.294,2.294,0,0,1,.481.855",
    transform: "translate(-9.904 -2.966)",
    fill: "#662d91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M231.557,122.044a1.49,1.49,0,0,1-1.882.093.844.844,0,0,0,.369-.312,1.166,1.166,0,0,0,1.482-.567,1.835,1.835,0,0,1,.031.786",
    transform: "translate(-8.407 -4.439)",
    fill: "#ed1e79"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 2.09,
    height: 1.134,
    transform: "matrix(0.449, -0.894, 0.894, 0.449, 218.83, 105.057)",
    fill: "#c1272d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 1.185,
    height: 0.643,
    transform: "translate(157.13 27.44) rotate(-87.766)",
    fill: "#ed1e79"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 5.705,
    height: 10.65,
    transform: "matrix(0.76, -0.649, 0.649, 0.76, 240.663, 45.506)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M291.1,14.557a3.8,3.8,0,0,0-3.581-3.272q.1-1.019.211-2.037a5.507,5.507,0,0,1,4.73,5.192c-.453.039-.906.076-1.36.117",
    transform: "translate(-10.525 -0.339)",
    fill: "#c1272d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 5.851,
    height: 2.922,
    transform: "matrix(0.999, -0.037, 0.037, 0.999, 306.592, 28.299)",
    fill: "#009245"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 4.271,
    height: 8.553,
    transform: "translate(272.939 67.195) rotate(-72.302)",
    fill: "#fcee21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M320.954,40.158c6.518-1.776,12.145,1.343,14,5.294a6.787,6.787,0,0,0-3.675,1.1c-2.1-2.718-7.558-4.183-12.6-.564a14.633,14.633,0,0,1,2.273-5.829",
    transform: "translate(-11.666 -1.451)",
    fill: "#662d91"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 5.492,
    height: 10.122,
    transform: "translate(240.76 23.298) rotate(-76.521)",
    fill: "#ed1e79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M349.192,48.36a2.381,2.381,0,0,0,3.036.146c.238.355.475.713.712,1.067a3.449,3.449,0,0,1-4.357-.616l.61-.6",
    transform: "translate(-12.76 -1.77)",
    fill: "#c1272d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 4.741,
    height: 2.572,
    transform: "matrix(0.777, -0.629, 0.629, 0.777, 337.861, 54.808)",
    fill: "#ed1e79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M500.378,10.377a12.609,12.609,0,0,0-.876,16.069l-5.674,3.738a18.269,18.269,0,0,1,3.4-23.056l3.155,3.249",
    transform: "translate(-17.98 -0.261)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M473.684,28.755a6.691,6.691,0,0,0-3.219-7.913q.938-1.538,1.878-3.077A9.7,9.7,0,0,1,475.935,29.6q-1.123-.422-2.251-.844",
    transform: "translate(-17.222 -0.65)",
    fill: "#c1272d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 2.264,
    height: 4.533,
    transform: "translate(512.961 64.358) rotate(-44.957)",
    fill: "#009245"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 1.272,
    height: 2.549,
    transform: "translate(458.179 49.336) rotate(-1.842)",
    fill: "#fcee21"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 8.162,
    height: 2.721,
    transform: "translate(499.107 77.368) rotate(-85.077)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M553.427,72.049a2.343,2.343,0,0,1,1.254,2.676,1.347,1.347,0,0,0-.671-.35,1.83,1.83,0,0,0-1.707-1.814,2.89,2.89,0,0,1,1.124-.513",
    transform: "translate(-20.217 -2.637)",
    fill: "#662d91"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 4.144,
    height: 7.639,
    transform: "matrix(0.678, -0.735, 0.735, 0.678, 442.955, 27.741)",
    fill: "#ed1e79"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 7.349,
    height: 3.936,
    transform: "translate(523.398 48.908) rotate(-77.454)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M652.134,38.913a4.621,4.621,0,0,0-3.383,4.831l-2.489.066a6.7,6.7,0,0,1,5.519-6.52q.176.814.354,1.623",
    transform: "translate(-23.657 -1.365)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 14.492,
    height: 7.238,
    transform: "matrix(0.999, -0.045, 0.045, 0.999, 605.482, 63.208)",
    fill: "#009245"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 3.233,
    height: 9.706,
    transform: "matrix(0.03, -1, 1, 0.03, 590.685, 63.744)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M633.258,79.872c-1.208,4.919-5.3,7.472-8.563,7.249a5.088,5.088,0,0,0,.618-2.808c2.542-.385,5.491-3.432,4.951-8.049a10.947,10.947,0,0,1,2.994,3.609",
    transform: "translate(-22.867 -2.792)",
    fill: "#662d91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M645.8,95.2c1.184-6.242,6.137-9.718,10.243-9.656a6.394,6.394,0,0,0-.586,3.56c-3.159.654-6.65,4.67-5.663,10.418A13.751,13.751,0,0,1,645.8,95.2",
    transform: "translate(-23.64 -3.132)",
    fill: "#ed1e79"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 1.341,
    height: 0.728,
    transform: "translate(607.966 114.717) rotate(-20.817)",
    fill: "#c1272d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 2.125,
    height: 1.153,
    transform: "translate(532.312 20.133) rotate(-38.445)",
    fill: "#ed1e79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M721.475,30.834a4.487,4.487,0,0,0-.421,5.709q-1.023.645-2.044,1.29a6.5,6.5,0,0,1,1.365-8.175l1.1,1.176",
    transform: "translate(-26.288 -1.086)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M702.326,115.959a2.853,2.853,0,0,0-.494,3.608l-1.349.738a4.134,4.134,0,0,1,1.192-5.136c.218.263.435.528.651.79",
    transform: "translate(-25.626 -4.216)",
    fill: "#009245"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M686.269,38.563a5.277,5.277,0,0,0-.713,6.7L683.1,46.706a7.654,7.654,0,0,1,1.917-9.57q.624.712,1.251,1.427",
    transform: "translate(-24.972 -1.359)",
    fill: "#c1272d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 13.064,
    height: 6.524,
    transform: "translate(687.316 61.151) rotate(-50.942)",
    fill: "#009245"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 5.287,
    height: 10.587,
    transform: "translate(678.079 69.59) rotate(-56.573)",
    fill: "#fcee21"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 7.911,
    height: 2.636,
    transform: "translate(684.885 81.681) rotate(-29.625)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 1.678,
    height: 1.941,
    transform: "matrix(0.14, -0.99, 0.99, 0.14, 643.346, 128.513)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M768.432,79.965a3.2,3.2,0,0,1,3.716-1.584,1.85,1.85,0,0,0-.512.9,2.5,2.5,0,0,0-2.557,2.243,3.928,3.928,0,0,1-.647-1.56",
    transform: "translate(-28.129 -2.864)",
    fill: "#662d91"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 0.986,
    height: 1.818,
    transform: "matrix(0.249, -0.969, 0.969, 0.249, 635.24, 57.841)",
    fill: "#ed1e79"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 13.356,
    height: 7.155,
    transform: "translate(31.56 176.943) rotate(-76.527)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M83.439,102.613a8.62,8.62,0,0,0-9,6.326l-4.407-1.466a12.487,12.487,0,0,1,13.815-7.928q-.2,1.533-.409,3.068",
    transform: "translate(-2.564 -3.637)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M56.892,146.784a2.831,2.831,0,0,0,3.606-.257c.329.387.661.773.991,1.16a4.1,4.1,0,0,1-5.232-.108l.635-.795",
    transform: "translate(-2.059 -5.364)",
    fill: "#c1272d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 8.193,
    height: 4.091,
    transform: "translate(42.865 201.994) rotate(-4.702)",
    fill: "#662d91"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 3.981,
    height: 7.337,
    transform: "translate(30.259 140.517) rotate(-77.612)",
    fill: "#ed1e79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M176.938,107.757a4.515,4.515,0,0,0,1.374,5.6l-1.555,1.874a6.547,6.547,0,0,1-1.24-8.257l1.421.784",
    transform: "translate(-6.39 -3.916)",
    fill: "#c1272d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 5.427,
    height: 2.711,
    transform: "translate(142.525 125.331) rotate(-26.406)",
    fill: "#fcee21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M658.188,116.528a12.546,12.546,0,0,0-6.788,14.5q-3.313.671-6.626,1.336a18.177,18.177,0,0,1,11.71-20.011q.853,2.085,1.7,4.171",
    transform: "translate(-23.594 -4.113)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 4.216,
    height: 8.441,
    transform: "matrix(0.555, -0.832, 0.832, 0.555, 545.012, 129.014)",
    fill: "#fcee21"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 2.018,
    height: 1.009,
    transform: "translate(695.351 187.665) rotate(-73.147)",
    fill: "#fcee21"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 1.894,
    height: 5.684,
    transform: "translate(672.009 192.959) rotate(-14.865)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M729.188,189.837a4.083,4.083,0,0,1,.525-5.131,2.337,2.337,0,0,0,.691,1.127,3.193,3.193,0,0,0,.928,4.246,5.057,5.057,0,0,1-2.143-.242",
    transform: "translate(-26.669 -6.761)",
    fill: "#662d91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M744.728,205.483a4.309,4.309,0,0,1-5.44.125,2.474,2.474,0,0,0,1.088-.872,3.371,3.371,0,0,0,4.324-1.529,5.332,5.332,0,0,1,.029,2.276",
    transform: "translate(-27.062 -7.439)",
    fill: "#ed1e79"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 1.02,
    height: 1.88,
    transform: "translate(705.933 180.754) rotate(-77.325)",
    fill: "#c1272d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M35.034,216.515a5.837,5.837,0,0,0-2.268-7.1q.919-1.277,1.841-2.552A8.462,8.462,0,0,1,36.935,217.4l-1.9-.885",
    transform: "translate(-1.199 -7.572)",
    fill: "#c1272d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccessful);
export default __webpack_public_path__ + "static/media/payment-successful.617a9435b74d31f1d4140fbf0b989c44.svg";
export { ForwardRef as ReactComponent };